const x = {
  /**
   * 2px corner radius.
   * Used for extra small rounded corners.
   */
  xs: "2px",
  /**
   * 3px corner radius.
   * Used for small rounded corners.
   */
  s: "3px",
  /**
   * 4px corner radius.
   * Used for medium rounded corners.
   */
  md: "4px",
  /**
   * 6px corner radius.
   * Used for large rounded corners.
   */
  lg: "6px",
  /**
   * 8px corner radius.
   * Used for extra large rounded corners.
   */
  xl: "8px",
  /**
   * 12px corner radius.
   * Used for 2x extra large rounded corners.
   */
  "2xl": "12px",
  /**
   * 16px corner radius.
   * Used for 3x extra large rounded corners.
   */
  "3xl": "16px",
  /**
   * 18px corner radius.
   * Used for 4x extra large rounded corners.
   */
  "4xl": "18px"
};
export {
  x as CORNER_RADIUS
};
//# sourceMappingURL=index.es704.js.map
